(function (angular) {
	angular.module('bizPartEngage').controller('modules.search', indexController);

    indexController.$inject = ["$stateParams", "bizCoreService", "$state"];

    function indexController($stateParams, bizCoreService, $state) {
		var vm = this;
		vm.ReferrerType = 'SearchPage';
		vm.ReferrerId = 0;
		vm.PageSize = 10;//setting
		vm.PageIndex = 0;
		vm.ResultCount = 0;
		vm.HitsIncement = 4;

		vm.SelectedIndex = 1;

		vm.OrderList = [/*{ Id: 0, Name: "Relevans" },*/ { Id: 2, Name: "Från A-Ö" }, { Id: 1, Name: "Senaste" }];
		vm.ShowAllIndex = { Index: 1, SearchIndexExternalName: "Alla resultat" };

        vm.SearchQuery = ($stateParams.query !== undefined ? decodeURIComponent($stateParams.query) : '');

		vm.Search = Search;
		vm.GoToResult = GoToResult;
		vm.GetResultHref = GetResultHref;
		vm.OnKeyPress = OnKeyPress;
		vm.SelectIndex = SelectIndex;

		vm.GetItemPreview = GetItemPreview;
		vm.GetStateUrl = GetStateUrl;
		vm.ShowCategory = ShowCategory;
		vm.ChangeSorting = ChangeSorting;

        vm.GetDate = GetDate;
        vm.HasValidDate = HasValidDate;

        function HasValidDate(date) {
            return !moment(date).isSameOrBefore('0001-01-01');
        }

		function GetDate(date) {
		    return moment(date).format('YYYY-MM-DD');
		}

		function OnKeyPress($event) {
			if ($event.keyCode == 13) {
				vm.Search();
			}
		}

		//function ChangeSorting(sortType) {
		//	vm.SortBy = sortType.Id;
		//	vm.Search();
	    //}
		function ChangeSorting(Id) {
		    vm.SortBy = Id;
		    vm.Search();
		}

		function Search() {		    
			if (!vm.SearchQuery) {
				return;
			}

			if (!vm.SearchIndexList) {
			    vm.SearchIndexList = [
                { Index: 2, TotalHits: vm.HitsIncement },
                { Index: 3, TotalHits: vm.HitsIncement },
                { Index: 4, TotalHits: vm.HitsIncement },
			    { Index: 5, TotalHits: vm.HitsIncement },
				{ Index: 6, TotalHits: vm.HitsIncement },
				{ Index: 7, TotalHits: vm.HitsIncement }];
            }
			
			vm.PageIndex = 0;
			var maxHits = (vm.PageIndex + 1) * vm.PageSize;

			bizCoreService.Search(vm.SearchQuery, maxHits, vm.ReferrerType, vm.ReferrerId, vm.IndexList, vm.SearchIndexList, vm.SortBy).then(SearchCallback);

			function SearchCallback(response) {
				if (!vm.IndexesToShow) {
					vm.IndexesToShow = response.data.IndexToShowList;
					for (var i = 0; i < vm.IndexesToShow.length; i++) {
						vm.IndexesToShow[i].TotalHits = vm.HitsIncement;
					}
					//vm.IndexesToShow.unshift({ Index: 1, SearchIndexExternalName: "Alla resultat" });
				}				
				vm.ResultItems = response.data.ResultItems;
				vm.SearchedQuery = vm.SearchQuery;				
				vm.ResultCount = response.data.TotalHits;

				HandleResults(vm.ResultItems);

				function HandleResults(results) {
					if (!results)
						return;

					for (var i = 0; i < results.length; i++) {
						results[i].StateUrl = vm.GetStateUrl(results[i]);
					}
				}
			}
		}


		function GoToResult(item) {
			bizCoreService.LogSearch(item);			
		}

		function GetResultHref(item) {
			return $state.href(item.State, JSON.parse(item.StateParameters));			
		}

		function GetStateUrl(item) {
            var url = decodeURI($state.href(item.State, JSON.parse(item.StateParameters), { absolute: false }));
			if (url.indexOf("#!") == 0) {
				url = url.substring(2);
            }
            if (url.indexOf("/") == 0 && url.indexOf(siteRootPath) == -1) {
                url = url.replace("/", siteRootPath);
			}			
			return url;
		}

		function GetItemPreview(item) {
			
			var preview = item.ItemPreview;			
			return preview || '';
		}

		function SelectIndex(index) {
		    if (vm.SelectedIndex) {
		        vm.SelectedIndex == index ? vm.SelectedIndex = undefined : vm.SelectedIndex = index;
		    }
		    else
		        vm.SelectedIndex = index;
		    
		}

		function ShowCategory(category) {			
			if (vm.ResultItems.GetItemsByValue('Index', category.Index).length > 0) {
		        if (vm.SelectedIndex){
		            if (vm.SelectedIndex != 1 && vm.SelectedIndex == category.Index)
		                return true;
		            else if (vm.SelectedIndex == 1)
		                return true;

		            return false;
		        }
		        else if(!vm.SelectedIndex)
		        {
		            return true;
		        }
		    }
		    else
		        return false;		    
		}

		function Init() {
			if (vm.SearchQuery) {
				vm.Search();
			}
		}

		this.$onInit = Init;
	}

})(window.angular);
